<template>
  <el-dialog width="1000px" v-bind="$attrs" v-on="$listeners" @open="onOpen" @close="onClose" :title="dialogTitle">
    <el-form :validate-on-rule-change="false" size="mini" :rules="rules" ref="ruleForm" :model="formData" :inline="true"
             label-width="150px" label-suffix="：">
      <div v-show="showEdit">
        <el-form-item label="重点客户名称">
          <el-input style="width: 300px" v-model="formData.title" @change="findDuplicate"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input placeholder="目标金额" v-model="formData.amount" style="width: 250px">
            <template slot="prepend">{{ formData.year || '' }}年度目标：</template>
            <template slot="append">￥</template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-link v-if="isEdit" @click="handleEditTitle"
                   style="margin-left: 10px;cursor: pointer;color: #ff3176">确定
          </el-link>
          <template v-if="formData.title&&showEdit">
            <i :class="is_exist?'el-icon-warning-outline':'el-icon-circle-check'" style="margin-left:10px;"
               :style="is_exist?'color:#E6A23C':'color:#67C23A'"></i>
            <span v-if="is_exist" style="margin-left: 10px;color:#E6A23C ">该公司名已被使用</span>
          </template>
        </el-form-item>
      </div>
      <div v-show="!showEdit">
        <el-form-item prop="title" label="重点客户名称">
          {{ formData.title || '' }}
        </el-form-item>
        <el-form-item prop="target_at" :label="targetTitle">
          {{ formData.amount || 0 }}
        </el-form-item>
        <el-form-item v-if="isEdit">
          <i class="el-icon-edit" title="修改客户名" style="cursor: pointer;margin-left: 10px;color: #fe346e" @click="showEdit=true" />
        </el-form-item>
      </div>
      <el-form-item prop="customer_id" label="关联客户">
        <CustomerRemoteSelect :model-value.sync="formData.customer_id"
                              @change="getOptionValue" ref="CustomerRemoteSelect" style="display: inline"
                              :TypeSize="'mini'"/>
        <el-button type="text" size="mini" icon="el-icon-add" @click="handleAdd" :disabled="loadingStatus"
                   :loading="loadingStatus"><span
            style="color: #ff3176;font-size: 14px;padding-left: 4px">
          <span class="el-icon-plus"></span>{{ isEdit ? '追加' : '添加' }}
        </span>
        </el-button>
      </el-form-item>
      <div class="default-table">
        <div>
          <el-link type="primary" @click="getList" icon="el-icon-refresh">刷新</el-link>
        </div>
        <el-table ref="apeTable"
                  :data="formData.items"
                  :loading="loadingStatus"
                  :isFullHeight="true"
                  highlight-current-row
                  header-align="center"
                  style="min-height: 300px"
                  align="center"
                  border
        >
          <el-table-column
              type="index"
              label="序号"
              header-align="center"
              align="center"
              width="50">
          </el-table-column>
          <el-table-column
              prop="customer_name"
              label="客户名称"
              align="center"
              header-align="left"
              width="320">
            <template scope="{row}">
              <div class="flex-align-center">
                <div> {{ row.customer_name || '' }}</div>
                <div class="default-table">
                  <el-popover
                      placement="right"
                      width="220"
                      trigger="click">
                    <el-table :data="row.sales">
                      <el-table-column align="center" property="sale" label="关联销售"></el-table-column>
                    </el-table>
                    <el-button type="text" slot="reference" title="关联销售：点击查看销售">
                      （{{ row.sales ? row.sales.length : 0 }}）
                    </el-button>
                  </el-popover>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" header-align="center" width="100" align="center">
            <template slot-scope="{row,$index}">
              <el-button type="text" size="mini" icon="el-icon-close"
                         @click="handleDelete(row,$index)">移除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div style="width: 100%;text-align: center;margin-top: 10px">
        <el-button size="big" v-if="!isEdit" type="primary" @click="onSubmit" :disabled="loadingStatus"
                   :loading="loadingStatus">保存
        </el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import CustomerRemoteSelect from "@/views/custom/components/CustomerRemoteSelect.vue";
import {
  addProfileCustomer,
  appendProfileCustomer,
  checkProfileCustomerTitle,
  editProfileCustomerTitle,
  getProfileCustomerInfo,
  removeProfileCustomerInfo
} from "@/api/profileCustomer";

const rule = {
  title: {required: true, message: '请输入重点客户名称', trigger: 'blur'},
  year: {required: true, message: '请输入目标年份', trigger: 'blur'},
  target_at: {required: true, message: '请输入目标日期', trigger: 'blur'},
  amount: {required: true, message: '请输入目标金额', trigger: 'blur'},
}

export default {
  name: "KeyAccountModal",
  components: {CustomerRemoteSelect},
  props: {
    formStore: {
      type: Object,
      default() {
        return {title: null, year: '', target_at: '', amount: 0}
      },
      required: true,
    },
  },
  data() {
    return {
      rules: {},
      loadingStatus: false,
      isEdit: true,
      formData: {},
      is_exist: false,
      editTitle: false,
      editData: false,
      showEdit: false,
      targetTitle: '',
    }
  },
  computed: {
    dialogTitle() {
      return this.isEdit ? '修改重点客户' : '新增重点客户'
    }
  },
  watch: {
    formStore(val) {
      this.isEdit = !!val.id;
      this.showEdit = !val.id;
      this.formData = {...val}
      this.targetTitle = this.formData.year + '年度目标'
    },
  },
  methods: {
    onOpen() {
      this.isEdit = this.formData.id;
      this.rules = rule
      if (this.isEdit) {
        this.getList()
      }
    },
    onClose() {
      this.rules = {}
      this.editTitle = false
      this.showEdit = false
      this.is_exist = false
      this.$emit('success')
    },
    async getList() {
      if (this.formData.id) {
        const {data: {info}} = await getProfileCustomerInfo({id: this.formData.id, target_at: this.formData.target_at})
        this.formData = info || []
      } else {
        this.formData = {}
      }
    },
    handleDelete(row, index) {
      if (row.id) {
        this.showModal({
          h: this,
          text: `确认删除【${row.customer_name}】吗？`,
          confirmText: "",
          cancelText: "",
          confirm: async () => {
            this.loadingStatus = true
            const response = await removeProfileCustomerInfo({id: row.id})
            if (!response.success) {
              this.showToast({h: this, icon: "el-icon-error", text: response.message, duration: 3000});
              return;
            }
            this.showToast({h: this, icon: "el-icon-success", text: '操作成功', duration: 2000});
            this.formData.items.splice(index, 1);
            this.loadingStatus = false
          }
        })
      } else {
        this.formData.items.splice(index, 1);
      }
    },
    async findDuplicate() {
      if (this.formData.title && this.formData.title !== '') {
        let data = {title: this.formData.title, id: this.formData.id || null}
        const {data: {is_exist}} = await checkProfileCustomerTitle(data)
        this.is_exist = is_exist
      }
    },
    getOptionValue() {
      let data = this.$refs.CustomerRemoteSelect.getOptionValue()
      this.customer = {
        customer_id: data.id, customer_name: data.name
      }
    },
    async handleAdd() {
      //添加逻辑
      if (this.isEdit) {
        let data = {
          id: this.formData.id,
          ...this.customer
        }
        let isExist = this.formData.items.find(item => item.customer_id === this.customer.customer_id)
        if (!isExist) {
          this.formData.items.push(data)
          this.loadingStatus = true
          const {data: {info}} = await appendProfileCustomer(data)
          if (info) {
            this.$message.success('追加成功！')
          }
          setTimeout(() => {
            this.loadingStatus = false
            this.getList()
          }, 200)
        } else {
          this.$message.warning('已关联该客户')
        }

        //单条添加
      } else {
        if (this.formData.title && this.formData.title !== '' && this.customer.customer_id) {
          this.$set(this.formData, "items", this.formData.items || [])
          // 批量添加
          let isExist = this.formData.items.find(item => item.customer_id === this.formData.customer_id)
          if (!isExist) {
            this.formData.items.push(this.customer)
            this.$forceUpdate()
          } else {
            this.$message.warning('已关联该客户')
          }
        }
      }
    },
    async onSubmit() {
      //新建
      this.loadingStatus = true
      const {data: {id}} = await addProfileCustomer(this.formData)
      if (id) {
        this.$message.success('新建成功！')
        this.$emit('success')
        setTimeout(() => {
          this.loadingStatus = false
        }, 200)
      }
    },
    async handleEditTitle() {
      this.editTitle = false
      this.showEdit = false
      const {data: {id}} = await editProfileCustomerTitle(this.formData)
      if (id) {
        this.$message.success('修改成功！')
        this.editTitle = false
        this.showEdit = false
      }
    }
  },
}
</script>


<style lang="scss" scoped>
::v-deep .default-table tr.el-table__row .cell {
  height: 30px !important;
  line-height: 30px !important;
  font-weight: normal;
}

::v-deep .el-input-group__prepend {
  padding-left: 10px;
  padding-right: 5px;
}
::v-deep .el-input-group__append {
  padding-left: 5px;
  padding-right: 10px;
}
</style>
